import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-bar" }

import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressComponent',
  props: {
  autoStart: Boolean,
  filled: Boolean,
  value: {
    type: Number,
    default: 100
  },
  variant: {
    type: String,
    default: 'plain',
    validator: (value: string) => ['success', 'error', 'plain'].includes(value)
  },
  duration: {
    type: Number,
    default: 5000
  }
},
  setup(__props) {

const progress = ref(0);
const props = __props;

watch(
  () => props.filled,
  (filledNew) => {
    progress.value = filledNew ? props.value : 0;
  }
);

onMounted(() => {
  if (props.autoStart) {
    fillProgressBarOverTime(); // Füllt die Fortschrittsleiste über 5 Sekunden
  }
  if (props.filled) {
    progress.value = props.value;
  }
});

/**
 * Function to fill the progress bar over time.
 * It calculates the elapsed time since the start time and updates the progress value accordingly.
 * If the elapsed time is less than the duration, it requests the next animation frame and calls itself again.
 * If the elapsed time is equal to or greater than the duration, it sets the progress value to the maximum value.
 */
const fillProgressBarOverTime = () => {
  const startTime = performance.now();
  const updateProgress = () => {
    const elapsedTime = performance.now() - startTime;
    if (elapsedTime < props.duration) {
      progress.value = (elapsedTime / props.duration) * props.value;
      requestAnimationFrame(updateProgress);
    } else {
      progress.value = props.value;
    }
  };
  requestAnimationFrame(updateProgress);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`progress --${props.variant}`),
      style: _normalizeStyle({ width: progress.value + '%' })
    }, null, 6)
  ]))
}
}

})